import { h } from 'preact';

/**
 * Reusable checkbox component
 * @param {Object} props
 * @param {boolean} props.checked - Checked state
 * @param {Function} props.onChange - Change handler
 * @param {string} props.label - Label text
 * @param {boolean} props.disabled - Disabled state
 * @param {string} props.className - Additional classes for the wrapper
 * @param {string} props.labelClassName - Additional classes for the label text
 * @param {string} props.inputClassName - Additional classes for the input element
 */
export default function Checkbox({
  checked = false,
  onChange,
  label,
  disabled = false,
  className = '',
  labelClassName = '',
  inputClassName = '',
  error = false,
  ...props
}) {
  return (
    <label className={`flex gap-2 items-center font-medium cursor-pointer text-sm  ${disabled ? 'opacity-50 cursor-not-allowed' : ''} ${className}`}>
      <input
        type="checkbox"
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        className={`h-4 w-4 rounded border-gray-300 text-white checked:accent-coit-red focus:ring-coit-red m-0 cursor-pointer ${
          error ? 'border-coit-error' : ''
        } ${inputClassName}`}
        {...props}
      />
      {label && (
        <span className={`text-gray-700 leading-tight ${labelClassName}`}>
          {label}
        </span>
      )}
    </label>
  );
}
